import React, { useRef } from "react";
import UserStore from "../../store/UserStore";
import { memo } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { monthData } from "../../utils/data";
import { formatCalenderDate, formatDateObj } from "../../utils/functions";
import { forwardRef } from "react";
import AccessibleDropdown from "./DropDownSelector";
import { useEffect } from "react";
import { useState } from "react";

const Calender = forwardRef(
  (
    {
      type,
      selectedDate,
      toSetCalDates,
      dateLimit,
      changeCalenderDates,
      limitDate,
      imitDateForTo,
      limitMonth,
      limitYear,
      containerRef,
      minDate = UserStore.forReportsInceptionDate,
    },
    ref
  ) => {
    const forMin = minDate?.split("-");
    const minMonth = Number(forMin[1]);
    const mindatChanged = `${forMin[0]}-${
      minMonth < 10 ? "0" + minMonth : minMonth
    }-${forMin[2]}`;

    const calenderSelectedDate = new Date(formatDateObj(selectedDate));

    const maxDate = new Date(limitDate);

    const [announcement, setAnnouncement] = useState("");
    const firstButtonRef = useRef(null);

    const [currentYear] = useState(new Date().getFullYear());

    const [getYearsList] = useState(
      Array(currentYear - (new Date(minDate).getFullYear() - 1))
        .fill()
        .map((_, i) => currentYear - i)
    );

    const monthRef = useRef(null);
    const yearRef = useRef(null);

    // const handleScrollYear = (e) => {
    //   const bottom =
    //     e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    //   if (
    //     bottom &&
    //     new Date(minDate).getFullYear() < getYearsList[getYearsList.length - 1]
    //   ) {
    //     const newYearList = [...getYearsList, ...Array(5)];
    //     if (!(newYearList.length > new Date().getFullYear())) {
    //       setYearsList(newYearList.fill().map((_, i) => currentYear - i));
    //     }
    //   }
    // };

    const changeDate = (completedData, mindatChanged) => {
      changeCalenderDates(
        completedData,
        type !== "from" ? limitDate : imitDateForTo,
        type,
        limitDate,
        mindatChanged
      );
    };

    const handleChange = (date) => {
      if (!date) return;
      changeDate(formatCalenderDate(date), mindatChanged);

      setTimeout(() => {
        if (containerRef?.current) {
          const el = containerRef.current.querySelector(
            ".react-datepicker__day--selected, .react-datepicker__day--keyboard-selected"
          );

          if (el) {
            el?.focus();
          }
        }
      }, 100);
    };

    const getYearsDisabledIndex = () => {
      const startingIndex = getYearsList.indexOf(maxDate.getFullYear());

      return startingIndex && startingIndex !== -1
        ? Array(startingIndex)
            .fill()
            .map((_, i) => startingIndex - (i + 1))
        : [-1];
    };

    const getDisabledMonthIndexArray = ({ currentYear, minDate, maxDate }) => {
      function getArrayIndex({ startMonthIndex }) {
        const result = [];
        for (let i = startMonthIndex + 1; i < 12; i++) {
          result.push(i);
        }

        return result;
      }

      function getMinDateArrayIndex({ lastMonthIndex }) {
        const result = [];
        for (let i = 0; i < lastMonthIndex; i++) {
          result.push(i);
        }

        return result;
      }

      if (currentYear === minDate.getFullYear()) {
        // If the selected year is the minimum year, disable all months before the minimum month

        const lastMonthIndex = minDate.getMonth();
        return getMinDateArrayIndex({ lastMonthIndex });
      } else if (currentYear === maxDate.getFullYear()) {
        // If the selected year is the maximum year, disable all months after the maximum month

        const startMonthIndex = maxDate.getMonth();
        return getArrayIndex({ startMonthIndex });
      }
    };

    useEffect(() => {
      setAnnouncement(
        `${type} ${new Date(formatDateObj(selectedDate)).toDateString()}`
      );
    }, [selectedDate]);

    return (
      <>
        <div ref={containerRef}>
          <DatePicker
            ref={ref}
            key={formatDateObj(selectedDate)}
            inline
            selected={calenderSelectedDate}
            // onChange={handleChange}
            onSelect={handleChange}
            maxDate={maxDate}
            minDate={new Date(mindatChanged)}
            //  calendarStartDate={viewDate} //
            renderCustomHeader={({ date, changeYear, changeMonth }) => {
              const currentYear = date.getFullYear();

              return (
                <div className="custom-month-year-wrapper">
                  {/* Month */}
                  <div ref={monthRef} id={`${type}-month-wrapper`}>
                    <AccessibleDropdown
                      label="Month"
                      options={monthData}
                      selectedIndex={date.getMonth()}
                      disabledIndexes={getDisabledMonthIndexArray({
                        currentYear,
                        minDate: new Date(mindatChanged),
                        maxDate,
                      })}
                      onChange={(month) => {
                        const newDate = new Date(
                          date.getFullYear(),
                          month,
                          calenderSelectedDate.getDate()
                        );

                        changeMonth(month);
                        changeDate(formatCalenderDate(newDate), mindatChanged);
                        //firstButtonRef.current.focus();
                        document
                          .getElementById(`${type}-month-selector`)
                          .focus();
                      }}
                      id={`${type}-month-selector`}
                      ref={firstButtonRef}
                    />
                  </div>
                  <div ref={yearRef} id={`${type}-month-wrapper`}>
                    <AccessibleDropdown
                      label="Year"
                      options={getYearsList}
                      selectedIndex={getYearsList.indexOf(date.getFullYear())}
                      disabledIndexes={getYearsDisabledIndex()}
                      onChange={(yearsIndex) => {
                        const year = getYearsList[yearsIndex];

                        const newDate = new Date(
                          year,
                          calenderSelectedDate.getMonth(),
                          calenderSelectedDate.getDate()
                        );

                        changeYear(year);
                        changeDate(formatCalenderDate(newDate), mindatChanged);
                        // const finalDate = newDate > maxDate ? maxDate : newDate;
                        document
                          .getElementById(`${type}-year-selector`)
                          .focus();
                      }}
                      id={`${type}-year-selector`}
                      ref={firstButtonRef}
                      wrapperClass={"year-dropdown"}
                    />
                  </div>
                </div>
              );
            }}
            formatWeekDay={(day) => day.substr(0, 3)}
            renderDayContents={(day, date) => (
              <div className="custom-day" aria-label={date.toDateString()}>
                {day}
              </div>
            )}
          />
        </div>

        <div aria-live="polite" aria-atomic="true" className="sr-only">
          {announcement}
        </div>
      </>
    );
  }
);

export default memo(Calender);
